import { FC } from 'react';
import { Box } from '@mui/material';

import { fontWeight, Heading, Text } from '../../../../../../../packages/ui/atoms/typography';
import { Icons } from '../../../../../../../packages/icons';
import { colors } from '../../../../../../../packages/colors';

import { useStyles } from './EvaluationEducation.styles';

const EvaluationEducation = ({ selectedSection, onClickDetail, setIsRead }) => {
  const classes = useStyles();
  const onClickDetailHandler = () => {
    selectedSection.evaluationResponses = [true];
    setIsRead(true);
    onClickDetail();
  };

  return (
    <>
      <Box className={classes.info} onClick={onClickDetailHandler}>
        <Icons glyph="book-side-filled-outlined" color={colors.primary500} />
        <Box>
          <Heading weight={fontWeight.BOLD} className={classes.infoTitle}>
            {selectedSection?.title}
          </Heading>
          {selectedSection?.duration && (
            <Text weight={fontWeight.MEDIUM} className={classes.infoSubtitle}>
              {selectedSection?.duration} read
            </Text>
          )}
        </Box>
      </Box>
    </>
  );
};

export { EvaluationEducation };
